import React from 'react'
import BackButton from '../BackButton/BackButton'
import s from './Header.module.scss'

export const Header = ({ title, description, onBack }) => (
	<div className={s.header}>
		{onBack ? <BackButton onClick={onBack} /> : null}
		<h1 className={s.header__title}>{title}</h1>
		{description ? <p className={s.header__description}>{description}</p> : null}
	</div>
)

export default Header
